const ITEMS = [
  "MaPrimeRénov'",
  "Prime CEE",
  "Éco-PTZ 0 %",
  "TVA 5,5 %",
  "RGE QualiPAC",
  "Daikin",
  "Mitsubishi Electric",
  "Atlantic",
  "Bosch",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap font-display text-xl font-bold text-white/85 sm:text-2xl">
          {item}
        </span>
        <span className="mx-8 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400/80" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee"
      className="relative overflow-hidden border-y border-white/10 bg-forest-dark py-6"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
